if (!customElements.get('slideshow-hero')) {
  customElements.define(
    'slideshow-hero',
    class SlideshowHero extends HTMLElement {
      connectedCallback() {
        this.progressBar = this.querySelector('.autoplay-progress-bar');
        this.swiperEle = this.querySelector('.swiper');
        this.slideContent = this.querySelector('.slide__content');
        this.slideTitle = this.slideContent?.querySelector('.slide__title');
        this.speed = parseInt(this.dataset.slideSpeed) || 5000;

        this.slideTitles = [...this.querySelectorAll('[data-item-index]')].map((item) => ({
          title: item.textContent.trim(),
          index: parseInt(item.dataset.itemIndex) - 1,
          link: item.dataset.link || '#',
        }));

        this.initFirstSlide();
        this.initSwiper();
        this.setupVideos();
        this.handleVideo();
      }

      initFirstSlide() {
        if (this.slideTitles.length > 0 && this.slideTitle) {
          const firstSlide = this.slideTitles[0];
          this.slideTitle.textContent = firstSlide.title;
          this.slideTitle.href = firstSlide.link;
          this.slideContent.style.width = this.measureTextWidth(firstSlide.title) + 'px';
        }
      }

      measureTextWidth(text) {
        const temp = document.createElement('span');
        Object.assign(temp.style, {
          visibility: 'hidden',
          position: 'absolute',
          whiteSpace: 'nowrap',
          fontSize: '12px',
          fontFamily: 'Red Hat Display',
          fontWeight: '700',
          textTransform: 'uppercase'
        });
        temp.textContent = text;
        document.body.appendChild(temp);
        const width = temp.offsetWidth + 20;
        document.body.removeChild(temp);
        return width;
      }

      updateContent(slideIndex) {
        const slideData = this.slideTitles[slideIndex];
        if (!slideData || !this.slideTitle) return;

        const newWidth = this.measureTextWidth(slideData.title);

        // Fade out
        this.slideContent.classList.add('fade-out');

        setTimeout(() => {
          this.slideTitle.textContent = slideData.title;
          this.slideTitle.href = slideData.link;
          this.slideContent.style.width = newWidth + 'px';

          // Fade in
          this.slideContent.classList.remove('fade-out');
          this.slideContent.classList.add('fade-in');

          setTimeout(() => {
            this.slideContent.classList.remove('fade-in');
          }, 300);
        }, 200);

        // Update heading
        const activeHeading = this.querySelector('.slide__heading.active');
        activeHeading?.classList.remove('active');
        const newHeading = this.querySelector(`[data-index='${slideIndex + 1}'].slide__heading`);
        newHeading?.classList.add('active');
      }

      initSwiper() {
        const _this = this;

        this.swiper = new Swiper(this.swiperEle, {
          slidesPerView: 1,
          loop: true,
          speed: 300,
          autoplay: {
            delay: this.speed,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.slideshow-next',
            prevEl: '.slideshow-prev',
          },
          on: {
            autoplayTimeLeft(s, time, progress) {
              _this.progressBar?.style.setProperty('--progress', 1 - progress);
            },
            slideChange() {
              _this.updateContent(this.realIndex);
              _this.handleVideo();
            },
          },
        });
      }

      setupVideos() {
        this.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          video.playsInline = true;
          video.style.pointerEvents = 'none';
          video.addEventListener('contextmenu', (e) => e.preventDefault());
          video.addEventListener('error', () => (video.style.display = 'none'));
        });
      }

      handleVideo() {
        if (!this.swiper) return;

        // Pause all videos
        this.querySelectorAll('video').forEach((v) => {
          try { v.pause(); } catch (e) {}
        });

        // Play current slide video
        const activeSlide = this.swiper.slides[this.swiper.activeIndex];
        const video = activeSlide?.querySelector('video');
        if (video) {
          video.currentTime = 0;
          video.play().catch(() => {});
        }
      }
    }
  );
}
